import React, { useEffect } from 'react';
import { initMetaPixel } from './components/pixel';
import { Hero, SocialProof } from './components/Hero';
import { TestimonialsSet1, TestimonialsSet2, Guarantee } from './components/Testimonials';
import { PainPoints, CostTable } from './components/PainPoints';
import { ProductOverview, Tomos, Bonuses } from './components/Product';
import { Urgency, PricingCards, Accelerator, FinalCTA } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { ToastNotification } from './components/ui';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-dark-bg text-white font-sans selection:bg-primary/30 selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <TestimonialsSet1 data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ProductOverview data-id="element-5" />
      <Tomos data-id="element-6" />
      <Bonuses data-id="element-7" />
      <Urgency data-id="element-8" />
      <PricingCards data-id="element-9" />
      <Accelerator data-id="element-10" />
      <TestimonialsSet2 data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <CostTable data-id="element-14" />

      <FinalCTA data-id="element-15" />

      <Footer data-id="element-16" />
      <ToastNotification data-id="element-17" />
    </div>;
}